import React from 'react';
import Scroll from 'react-scroll';
import Form from 'react-bootstrap/Form';

class FieldToggle extends React.Component {

  render() {
    const key = this.props.id;
    const field = this.props.field;
    const visible = this.props.visible;
    const editable = this.props.editable;
    const mandatory = this.props.mandatory;
    const value = this.props.value;
    const error = this.props.error;
    const errorMessage = this.props.errorMessage;

    if(!visible || !editable) return null;
    
    return (
      <div className="col">
        <div className="form-group">
          <Scroll.Element name={this.props.id} />
          <label> {field.label_name} { mandatory ? <span className="required-field"/> : null} </label>
          { error ? <>&nbsp; : &nbsp; <label className="error-w">{errorMessage}</label></> : null }
          <Form.Check
            onChange={event => this.props.onValueChange(key, event.target.checked)}
            checked={value}
            readOnly={!editable}
          />
        </div>
      </div>
    );
  }
}
export default FieldToggle;